import NotFound from "./components/NotFound.vue";
import Forbidden from "./components/Forbidden.vue";

export default [
    {
        path: "/dashboard",
        component: require("./components/Dashboard.vue").default,
    },
    {
        path: "/stock-gudang",
        component: require("./views/stock-gudangs/Index.vue").default,
    },
    {
        path: "/pembelian-tembakau",
        component: require("./views/pembelian-tembakaus/Index.vue").default,
    },
    {
        path: "/pindah-gudang",
        component: require("./views/pindah-gudangs/Index.vue").default,
    },
    {
        path: "/stripping",
        component: require("./views/strippings/Index.vue").default,
    },
    {
        path: "/re-dry",
        component: require("./views/re-dries/Index.vue").default,
    },
    {
        path: "/blending",
        component: require("./views/blendings/Index.vue").default,
    },
    {
        path: "/repack",
        component: require("./views/repacks/Index.vue").default,
    },
    {
        path: "/beli-lepas",
        component: require("./views/beli-lepas/Index.vue").default,
    },
    {
        path: "/tebasan",
        component: require("./views/tebasans/Index.vue").default,
    },

    // keuangan
    {
        path: "/pembayaran-supplier",
        component: require("./views/pembayaran-suppliers/Index.vue").default,
    },
    {
        path: "/nota-supplier",
        component: require("./views/nota-suppliers/Index.vue").default,
    },
    {
        path: "/nota-supplier/create",
        component: require("./views/nota-suppliers/CreateNota.vue").default,
    },
    {
        path: "/pinjaman-supplier",
        component: require("./views/pinjaman-suppliers/Index.vue").default,
    },
    {
        path: "/komisi-grader",
        component: require("./views/komisi-graders/Index.vue").default,
    },
    {
        path: "/penjualan-tembakau",
        component: require("./views/penjualan-tembakaus/Index.vue").default,
    },
    {
        path: "/inventaris-barang",
        component: require("./views/inventaris-barangs/Index.vue").default,
    },
    {
        path: "/surat-jalan",
        component: require("./views/surat-jalans/Index.vue").default,
    },
    {
        path: "/mutasi-cash",
        component: require("./views/mutasi-cashs/Index.vue").default,
    },
    {
        path: "/mutasi-transfer",
        component: require("./views/mutasi-transfers/Index.vue").default,
    },
    {
        path: "/pengeluaran-gudang",
        component: require("./views/pengeluaran-gudangs/Index.vue").default,
    },
    {
        path: "/pengisian-dana-gudang",
        component: require("./views/pengisian-dana-gudangs/Index.vue").default,
    },
    {
        path: "/rekening-gudang",
        component: require("./views/rekening-gudang/Index.vue").default,
    },
    {
        path: "/pengisian-dana-gudang/history",
        component: require("./views/pengisian-dana-gudangs/History.vue")
            .default,
    },
    {
        path: "/kas-kecil",
        component: require("./views/kas-kecils/Index.vue").default,
    },
    {
        path: "/inventory-pendukung",
        component: require("./views/inventory-pendukungs/Index.vue").default,
    },

    {
        path: "/stock-opname",
        component: require("./views/stock-opnames/Index.vue").default,
    },

    // master data
    {
        path: "/users",
        component: require("./views/users/Index.vue").default,
    },
    {
        path: "/gudangs",
        component: require("./views/gudangs/Index.vue").default,
    },
    {
        path: "/grades",
        component: require("./views/grades/Index.vue").default,
    },
    {
        path: "/suppliers",
        component: require("./views/suppliers/Index.vue").default,
    },

    {
        path: "*",
        component: NotFound,
    },
    {
        path: "/forbidden",
        component: Forbidden,
    },

    {
        path: "/profile",
        component: require("./components/Profile.vue").default,
    },
    {
        path: "/developer",
        component: require("./components/Developer.vue").default,
    },
    {
        path: "/products",
        component: require("./components/product/Products.vue").default,
    },
    {
        path: "/product/tag",
        component: require("./components/product/Tag.vue").default,
    },
    {
        path: "/product/category",
        component: require("./components/product/Category.vue").default,
    },
];
